// removed by extract-text-webpack-plugin
module.exports = {"singleItem":"fmQOM2n5F9BGqJiqDzZsL","title":"_1Ho_-HcYVIXuMvBPphPG4X","alink":"_2QHEo467pa5St7ZXDQ8qbG","cont_box":"_26V59k8qhw0x094zWQpy_d","invoiceContent":"_2Y73mt-z0vIEGFvVRut_vt","header":"_1HKCUEnhKUuzb_xtDLfjW9","rada":"_3gFwSG9Rz_v5fHtOwBkwzo","fla":"yEPrVTPdDq--ubTvSIQSB","active":"cAC5Uerhw0cCThQyaQuR4","buttonModify":"_2dwWIijW727PpY8CsT4tLI","inpt":"_389ksB2gRTwbBioOxeFyr1","txt":"_1yiuKRYgvUDRr374w-3llR","link_a":"_2lTZ5DJlhpJDRwEoJe16N6","selt":"_21bo-7IMSv7V9hkIXX_1OK","mt0":"_2ky5HASbC9CStK33V_hr7Q","mt20":"_23LuJj4sU3xTteR1M2aFZN","ml60":"_1BbGalLcnLk4If59ECphWu","ml105":"_3z8BNuBtBr-WNfUzrHWrMj"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OrderWritingInfo/OrderWritingInfo.scss
 ** module id = 1005
 ** module chunks = 0
 **/